import React, { Component } from 'react'
import '../style/Footer.css';
export class Footer extends Component {
    render() {
        return (
            <div id="footer">
               <div id="footerPanels"></div>
               <span id="footerCopy">Copyright © CardanoCookies 2021. All Rights Reserved.</span>
            </div>
        )
    }
}

export default Footer
